import { Component } from 'react';
import IbssTextField from '../../../../../Components/Inputs/TextField/IbssTextField';
import IbssCheckBox from '../../../../../Components/Inputs/CheckBox/IbssCheckBox';
import { Slider } from '@mui/material';
import IbssInputDropDown from '../../../../../Components/Inputs/SelectList/IbssInputDropDown';
import { appContext } from '../../../../../AppContext';
import { IbssComponent } from '../../../../../Components/Core/BaseComponent/IbssComponent';

class OpenQuestionForm extends IbssComponent<IProps, IState>
{

    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            helperTextChecked: false
        };
    };

    public componentDidMount(): void
    {
        this.setState({ helperTextChecked: this.props.helperText.length > 0 });
    }

    private helperTextCheckboxSelected(checked: boolean): void
    {
        this.setState({ helperTextChecked: checked });
        if (checked == false)
        {
            this.props.onHelperTextChange('');
        }
    }

    public render(): JSX.Element
    {
        return (
            <div>
                <div className='m-4'>
                    <IbssTextField required value={this.props.questionName} className='mb-1' fullWidth variant='standard' label={this.labels.funcVisitorTypeQuestionName_S} onChange={(e) => this.props.onQuestionNameChange(e.target.value)} maxLength={500} />
                    <IbssTextField value={this.props.placeholder} className='mb-1' fullWidth variant='standard' label={this.labels.funcVisitorTypePlaceholderText_S} onChange={(e) => this.props.onPlaceholderTextChange(e.target.value)} />
                    <IbssCheckBox checked={this.state.helperTextChecked} label={this.labels.funcVisitorTypeHelperText_S} onClicked={(e: { target: { checked: boolean; }; }) => this.helperTextCheckboxSelected(e.target.checked)} />
                    {
                        this.state.helperTextChecked &&
                        <IbssTextField value={this.props.helperText} fullWidth variant='standard' label={this.labels.funcVisitorTypeHelperText_S} onChange={(e) => this.props.onHelperTextChange(e.target.value)} />
                    }
                </div>
                <hr />
                <div className='m-4'>
                    <div>{this.labels.funcMaxLength_S}</div>
                    <div className='d-flex'>
                        <Slider value={this.props.maxLength} max={500} onChange={(event, value) => this.props.onMaxLengthChange(value as number)} className='mt-1' />
                        <IbssTextField value={this.props.maxLength} className='ml-4' type='number' onChange={(e) => this.props.onMaxLengthChange(parseInt(e.target.value))} />
                    </div>
                    <div className='mb-1'>
                        <IbssCheckBox checked={this.props.required} label={this.labels.funcRequiredField_S} onClicked={(e: { target: { checked: boolean; }; }) => this.props.onRequiredChange(e.target.checked)} />
                    </div>
                    <IbssInputDropDown
                        value={this.props.inputHeight}
                        onChange={(e) => this.props.onInputHeightChange(e.target.value)}
                        inputLabel={this.labels.funcInputHeight_S} id='inputHeight' options={[{ label: this.labels.funcSingleLine_S, value: 'single' }, { label: this.labels.funcMultiLine_S, value: 'multi' }]}
                    />
                </div>
            </div>
        )
    }
}

export default OpenQuestionForm;

export interface IProps
{
    onQuestionNameChange: (value: string) => void;
    questionName: string;
    onPlaceholderTextChange: (value: string) => void;
    placeholder: string
    onHelperTextChange: (value: string) => void;
    helperText: string
    onMaxLengthChange: (value: number) => void;
    maxLength: number;
    onRequiredChange: (value: boolean) => void;
    required: boolean
    onInputHeightChange: (value: string) => void;
    inputHeight: string;
}

export interface IState
{
    helperTextChecked: boolean;
}